let BASE_URL = "https://www.chemical-link.com";
// let BASE_URL = "http://huagong.hebeilingyan.com";
// let BASE_URL = "http://huagong.hbrjkf.cn";
let IMAGE_URL = "";


// if(process.env.NODE_ENV === 'production'){
// 	 BASE_URL = "huagong.hbrjkf.cn";
// }else{
// 	 BASE_URL = "/api";
// }

let config = {
	BASE_URL:BASE_URL+'/api',
	IMG_URL:IMAGE_URL,
	UPLOAD_PATH:BASE_URL + "/index/Upload/upload",
	YX_APPKEY:"e0c2a15491308fe90d3aec04f9025d45",
	WECHAT_OPEN_APPID:"wx33909e8ecfc78fd4",
}

export default config;
